import { Tabs } from "@dealer-center/core-components";
import { AutoDataOptions } from "./vin-decode-options";
import { AutoDataColors } from "./vin-decode-colors";
import { AutoDataTechSpecs } from "./vin-decode-tech-specs";
import { useParams } from "react-router-dom";
import type { indexMappingKeys } from "./helper";
import { indexMapping } from "./helper";

interface PagesVinDecodeTabsProps {
  selectedTab: indexMappingKeys;
  setSelectedTab: (index: indexMappingKeys) => void;
}
export function PagesAutoDataTabs({
  selectedTab,
  setSelectedTab
}: PagesVinDecodeTabsProps) {
  const { trim: trimParam } = useParams();
  const selectedTrim = trimParam || undefined;
  if (!selectedTrim) return null;
  return (
    <>
      <h2>Selected Trim {selectedTrim}</h2>
      <Tabs
        tabs={[
          {
            active: selectedTab === indexMapping.options,
            label: "Options",
            component: <AutoDataOptions vehicleId={selectedTrim} />
          },
          {
            active: selectedTab === indexMapping.colors,
            label: "Colors",
            component: <AutoDataColors vehicleId={selectedTrim} />
          },
          {
            active: selectedTab === indexMapping.techSpecs,
            label: "Tech Specs",
            component: <AutoDataTechSpecs vehicleId={selectedTrim} />
          }
        ]}
        onActivate={index => {
          setSelectedTab(index);
        }}
      />
    </>
  );
}

export default PagesAutoDataTabs;
